<div>
    <input type="text" class="form-control my-2"  (keyup)="search($event)"  placeholder="Recherche medic">
    <nav class="tree-nav scroll" >

        <div class="flex" *ngFor="let medic of medics ;let i= index" >
            <div style="display: flex;flex-direction: column;">
                <span class="label">{{medic.nom}}</span>
                <div class="d-flex flex-wrap gap-3">                <span  >{{medic.co}}</span> <span style="color: #b1005a;">({{medic.nom_generique}})</span>
 </div>
            </div>
            <input type="checkbox" name="" id=""  class="checkbox" (change)="changed(medic,$event,i)"   >
        </div>
        </nav>
        <button class="btn btn-primary ajouter" (click)="close()">Ajouter</button>
</div>
